// extracted by mini-css-extract-plugin
export default {"toggler":"MobileMenuToggler_toggler__1Sv3k","hamburger":"MobileMenuToggler_hamburger__8bE2G","label":"MobileMenuToggler_label__oNRuj"};